import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAllTags, deleteTag } from "./TagService";

export default function TagList() {
  const [tags, setTags] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    loadTags();
  }, []);

  const loadTags = async () => {
    const data = await getAllTags();
    setTags(data);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this tag?")) return;
    await deleteTag(id);
    loadTags();
  };

  return (
    <div>
      <button onClick={() => navigate("new")}>➕ Add Tag</button>

      <table style={{ width: "100%", marginTop: "20px" }}>
        <thead>
          <tr>
            <th align="left">Tag</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {tags.map(tag => (
            <tr key={tag.id}>
              <td>{tag.tagName}</td>
              <td>
                <button onClick={() => navigate(`edit/${tag.id}`)}>✏️</button>
                <button onClick={() => handleDelete(tag.id)}>🗑️</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
